/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Template_Preset_LabelInputs */

const en_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Preset`)
};

const fr_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prereglage de modele`)
};

const de_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

const it_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello predefinito`)
};

const ru_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданный шаблон`)
};

const es_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla preestablecida`)
};

const zh_cn2_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板预设`)
};

const ja_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートプリセット`)
};

const hi_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेम्पलेट प्रीसेट`)
};

const pt_pt2_transcript_export_template_preset_label = /** @type {(inputs: Transcript_Export_Template_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo predefinido`)
};

/**
* | output |
* | --- |
* | "Template Preset" |
*
* @param {Transcript_Export_Template_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_template_preset_label = /** @type {((inputs?: Transcript_Export_Template_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Template_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_template_preset_label(inputs)
	if (locale === "de") return de_transcript_export_template_preset_label(inputs)
	if (locale === "it") return it_transcript_export_template_preset_label(inputs)
	if (locale === "ru") return ru_transcript_export_template_preset_label(inputs)
	if (locale === "es") return es_transcript_export_template_preset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_template_preset_label(inputs)
	if (locale === "ja") return ja_transcript_export_template_preset_label(inputs)
	if (locale === "hi") return hi_transcript_export_template_preset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_template_preset_label(inputs)
	return en_transcript_export_template_preset_label(inputs)
});